import React from 'react';
import { Link } from 'react-router-dom';
import './TrepHeader.css';

const TrepHeader = ({ onRequestAccess, onContactSales }) => {
  return (
    <header className="modern-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-team">team</span>
          <span className="logo-reports">reports</span>
          <span className="logo-team">.i</span>
          <span className="logo-reports">o</span>
        </Link>

        <nav className="nav-menu">
          <a href="/#features" className="nav-link">Features</a>
          <a href="/#usecases" className="nav-link">Use Cases</a>
          <a href="/#pricing" className="nav-link">Pricing</a>
          <span className="nav-link disabled" title="Coming Soon">Docs</span>
        </nav>

        <div className="header-cta">
          <button className="header-button" onClick={onRequestAccess}>Request Access</button>
          <button className="header-button outline" onClick={onContactSales}>Contact Sales</button>
        </div>
      </div>
    </header>
  );
};

export default TrepHeader;
